import "core-js/modules/es.array.fill.js";
import * as React from 'react';
function WarningFill(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    width: 24,
    height: 24,
    fill: props !== null && props !== void 0 && props.fill ? props.fill : 'none',
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": props['aria-label']
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.304 18.749A1.5 1.5 0 003.602 21h16.796a1.5 1.5 0 001.299-2.252L13.298 4.242a1.5 1.5 0 00-2.596 0L2.304 18.75zM13 18h-2v-2h2v2zm0-4h-2v-4h2v4z",
    fill: props.fill
  }));
}
export default WarningFill;